import React from 'react';
import Icon from './Icon';

// Renders a single screen block descriptor (see homeData block builders).
const Block = ({ block }) => {
  switch (block.type) {
    case 'fields':
      return (
        <div className="sb-fields">
          {block.items.map((f, i) => (
            <div className="sb-field" key={i}>
              <div className="sb-field-label">{f.label}</div>
              <div className="sb-field-value" style={{ fontFamily: f.family }}>{f.value}</div>
            </div>
          ))}
        </div>
      );

    case 'table':
      return (
        <div className="sb-table">
          <div className="sb-thead" style={{ gridTemplateColumns: block.grid }}>
            {block.cols.map((c, i) => (
              <span key={i} style={{ textAlign: c.align }}>{c.t}</span>
            ))}
          </div>
          {block.rows.map((r, ri) => (
            <div className="sb-trow" style={{ gridTemplateColumns: block.grid }} key={ri}>
              {r.cells.map((c, ci) => (
                <span
                  key={ci}
                  style={{ textAlign: c.align, fontWeight: c.weight, fontFamily: c.family, color: c.color }}
                >
                  {c.isChip ? (
                    <span className="sb-chip-cell" style={{ color: c.chipColor, background: c.chipBg }}>{c.text}</span>
                  ) : (
                    c.text
                  )}
                </span>
              ))}
            </div>
          ))}
        </div>
      );

    case 'kpis':
      return (
        <div className="sb-kpis">
          {block.items.map((k, i) => (
            <div className="sb-kpi" style={{ background: k.bg, borderColor: k.border }} key={i}>
              <div className="sb-kpi-label">{k.label}</div>
              <div className="sb-kpi-value" style={{ color: k.color }}>{k.value}</div>
            </div>
          ))}
        </div>
      );

    case 'progress':
      return (
        <div className="sb-progress">
          {block.items.map((p, i) => (
            <div key={i}>
              <div className="sb-progress-head">
                <span className="sb-progress-label">{p.label}</span>
                <span className="sb-progress-note">{p.note}</span>
              </div>
              <div className="sb-progress-track">
                <div className="sb-progress-fill" style={{ width: p.pct, background: p.color }} />
              </div>
            </div>
          ))}
        </div>
      );

    case 'chips':
      return (
        <div className="sb-chips">
          {block.items.map((c, i) => (
            <span className="sb-chip" style={{ color: c.color, background: c.bg }} key={i}>
              <span className="sb-chip-dot" style={{ background: c.color }} />
              {c.text}
            </span>
          ))}
        </div>
      );

    case 'total':
      return (
        <div className="sb-total">
          <span className="sb-total-label">{block.label}</span>
          <span className="sb-total-value">{block.value}</span>
        </div>
      );

    case 'note':
      return (
        <div className="sb-note">
          <span className="sb-note-icon"><Icon name="info" size={14} /></span>
          <span className="sb-note-text">{block.text}</span>
        </div>
      );

    default:
      return null;
  }
};

const ScreenBlocks = ({ blocks }) => (
  <div className="sb-stack">
    {blocks.map((b, i) => <Block block={b} key={i} />)}
  </div>
);

export default ScreenBlocks;
